import React from 'react'
import { HomeFilterForm } from '../containers/HomeFiltersForm'
import StudiKwIndexListing from '../containers/StudiKwIndex/StudiKwIndexListing'
import { FilterDataProvider } from '../HOC/studiKwFiltersContext'
import SetTitle from '../utils/set_title'
import Header from '../components/Headers/Header'

const SchedulingIndex = () => {
  SetTitle('Scheduled Ranking Index')

  return (
    <FilterDataProvider path="studiokw-scheduled/" >
      <Header
        iconClass="ni ni-time-alarm text-white"
        title="Scheduled Ranking Index"
        docLink="/docs/ranking_tools/scheduling/"
        headerClassName="main-page-title"
        headerChildren={<HomeFilterForm />}
      >
        <StudiKwIndexListing />
      </Header>
  </FilterDataProvider>
  )
}

export default SchedulingIndex